import useChannel from '../hooks/useChanell'
import React, { useEffect, useState, useMemo } from 'react'
import { createConsumer } from '@rails/actioncable'
import { wsUrl } from '../consts/other'
import { useDispatch } from 'react-redux'
import getCognitoAccessToken from './getCognitoAccessToken'
import {
  ADD_MESSAGE,
  SET_ADMIN_FINISH_TYPING,
  SET_ADMIN_START_TYPING,
  ADD_NEW_OFFER_TO_LIST,
  ADD_NOTIFICATIONS,
  ADD_OR_UPDATE_CONVERSATION,
  CREATE_BET_SUCCESS
} from 'dealer-reducers'

const WebSocketConnector = (): JSX.Element => {
  const [token, setToken] = useState('')

  useEffect(() => {
    const fetchToken = async (): Promise<void> => {
      const fetchedToken = await getCognitoAccessToken()
      setToken(fetchedToken ?? '')
    }
    fetchToken().catch(null)
  }, [])
  return <>{token !== '' && <WebSocketComponent token={token} />}</>
}

export default WebSocketConnector

const WebSocketComponent = ({ token }: { token: string }): JSX.Element => {
  const actionCable = useMemo(() => createConsumer(`${wsUrl}?token=${token}`), [token])
  const { subscribe, unsubscribe } = useChannel(actionCable)
  const dispatch = useDispatch()

  useEffect(() => {
    subscribe(
      { channel: 'DealerOffersChannel' },
      {
        received: (data) => {
          dispatch(ADD_NEW_OFFER_TO_LIST({ offer: data.offer, tab: 'browse' }))
        }
      }
    )
    return () => {
      unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    subscribe(
      { channel: 'InAppNotificationsChannel' },
      {
        received: (data) => {
          dispatch(ADD_NOTIFICATIONS(data))
        }
      }
    )
    return () => {
      unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    subscribe(
      { channel: 'BetsChannel' },
      {
        received: (data) => {
          dispatch(CREATE_BET_SUCCESS({ offer: data.offer }))
        }
      }
    )
    return () => {
      unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    subscribe(
      { channel: 'ChatChannel' },
      {
        received: (data) => {
          if (data?.message?.author === 'admin') {
            dispatch(ADD_OR_UPDATE_CONVERSATION(data.conversation_list_element))
            dispatch(ADD_MESSAGE(data.message))
            dispatch(SET_ADMIN_FINISH_TYPING())
          }
          if (typeof data.start_typing_at === 'string') {
            dispatch(SET_ADMIN_START_TYPING())
          }
        }
      }
    )
    return () => {
      unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}
